// themeConfig.js
// Centralized theme + link config for IDM UI

// 1) Themes define default (global) behavior/links for that theme
export const THEMES = {
    QG: {
        name: 'QG',
        // default links for QG (US English)
        links: {
            terms: {
                default: 'https://www.pearsonassessments.com/footer/terms-of-sale---use.html',
                'en-us': 'https://www.pearsonassessments.com/footer/terms-of-sale---use.html',
                'en-au': 'https://www.pearsonclinical.com.au/qglobal_terms',
                'en-ca': 'https://www.pearsonclinical.ca/en/legal/terms-of-sale-use.html',
                'en-gb': 'https://www.pearsonclinical.co.uk/legal/terms-of-sale-use.html',
                'en-in': 'http://pearsonclinical.in/terms/',
                'fr': 'https://admin.pearsonclinical.eu/media/wysiwyg/CGV_2023.pdf',
                'es': 'https://www.pearsonclinical.es/mwdownloads/download/link/id/1290/',
                'da': 'https://www.pearsonclinical.dk/bestillingsvilkar',
                'de': 'https://www.pearsonclinical.de/agb',
                'nl': 'https://www.pearsonclinical.nl/over-pearson/klantenservice/algemene-voorwaarden',
                'no': 'https://www.pearsonclinical.no/bestillingsvilkar-no',
                'sv': 'https://www.pearsonclinical.se/bestallningsvillkor'
            },
            privacy: {
                default: 'https://www.pearsonassessments.com/footer/pearson-clinical-privacy-policy.html',
                'en-us': 'https://www.pearsonassessments.com/footer/pearson-clinical-privacy-policy.html',
                'en-au': 'https://www.pearsonclinical.com.au/privacy',
                'en-ca': 'https://www.pearsonclinical.ca/en/legal/pearson-clinical-privacy-policy.html',
                'en-gb': 'https://www.pearsonclinical.co.uk/legal/pearson-clinical-privacy-policy.html',
                'en-in': 'http://pearsonclinical.in/privacy-policy/',
                'fr': 'https://www.pearsonclinical.fr/mwdownloads/download/link/id/771/',
                'es': 'https://www.pearsonclinical.es/mwdownloads/download/link/id/1289/',
                'da': 'https://www.pearsonclinical.dk/mwdownloads/download/link/id/1499',
                'de': 'https://www.pearsonclinical.de/datenschutz',
                'nl': 'http://www.pearsonclinical.nl/privacyverklaring-q-global-q-interactive',
                'no': 'https://www.pearsonclinical.no/mwdownloads/download/link/id/1501',
                'sv': 'https://www.pearsonclinical.se/mwdownloads/download/link/id/1554/'
            },
            accessibility: {
                default: 'https://www.pearson.com/en-us/legal-information/accessibility'
            },
            businessAssociate: {
                default: 'https://www.pearsonassessments.com/content/dam/school/global/clinical/us/assets/q-global/Q-global-Business-Associate-Addendum.pdf',
                'en-us': 'https://www.pearsonassessments.com/content/dam/school/global/clinical/us/assets/q-global/Q-global-Business-Associate-Addendum.pdf'
            },
            contact: {
                default: 'https://support.pearson.com/usclinical/s/contactsupport',
                'en-us': 'https://support.pearson.com/usclinical/s/contactsupport',
                'en-au': 'https://support.pearson.com/usclinical/s/contactsupport',
                'en-ca': 'https://support.pearson.com/usclinical/s/contactsupport',
                'en-gb': 'https://support.pearson.com/usclinical/s/contactsupport',
                'fr': 'https://support.pearson.com/usclinical/s/contactsupport',
                'es': 'https://support.pearson.com/usclinical/s/contactsupport',
                'da': 'https://support.pearson.com/usclinical/s/contactsupport',
                'de': 'https://support.pearson.com/usclinical/s/contactsupport',
                'nl': 'https://support.pearson.com/usclinical/s/contactsupport',
                'no': 'https://support.pearson.com/usclinical/s/contactsupport',
                'sv': 'https://support.pearson.com/usclinical/s/contactsupport'
            },
            license: {
                default: 'https://www.pearsonassessments.com/content/dam/school/global/clinical/us/assets/q-global/Q-global-License-Agreement.pdf',
                'en-us': 'https://www.pearsonassessments.com/content/dam/school/global/clinical/us/assets/q-global/Q-global-License-Agreement.pdf',
                'en-au': 'https://www.pearsonclinical.com.au/content/dam/school/global/clinical/au/assets/q-global/q-global-license-agreement.pdf',
                'en-ca': 'https://www.pearsonclinical.ca/content/dam/school/global/clinical/ca/assets/q-global/Q-global-License-Agreement-CA.pdf',
                'en-gb': 'https://www.pearsonclinical.co.uk/content/dam/school/global/clinical/us/assets/q-global/Q-global-License-Agreement.pdf',
                'en-in': 'https://pearsonclinical.in/legal-policies/',
                'fr': 'https://www.pearsonclinical.fr/mwdownloads/download/link/id/1777',
                'es': 'https://www.pearsonclinical.es/aviso-legal',
                'da': 'https://www.pearsonclinical.dk/mwdownloads/download/link/id/1498/',
                'de': 'https://www.pearsonclinical.de/agb',
                'nl': 'https://www.pearsonclinical.nl/q-global-gebruiksvoorwaarden',
                'no': 'https://www.pearsonclinical.no/mwdownloads/download/link/id/1500',
                'sv': 'https://www.pearsonclinical.se/media/wysiwyg/Q-global/SEQ-Global_-_Terms_Conditions_-_Sweden_-_Feb_2018_uppdaterad2021_.pdf'
            },
            about: {
                default: 'https://www.pearsonassessments.com/professional-assessments/digital-solutions.html',
                'en-us': 'https://www.pearsonassessments.com/professional-assessments/digital-solutions.html',
                'en-au': 'https://www.pearsonclinical.com.au/digital-solutions.html',
                'en-ca': 'https://www.pearsonclinical.ca/en/digital-solutions.html',
                'en-gb': 'https://www.pearsonclinical.co.uk/digital-solutions.html',
                'en-in': 'http://pearsonclinical.in/about-us/',
                'fr': 'https://www.pearsonclinical.fr/qui-sommes-nous/ecpa-pearson',
                'es': 'https://www.pearsonclinical.es/sobre-pearson',
                'da': 'https://www.pearsonassessment.dk/om-pearson',
                'de': 'https://www.pearsonclinical.de/digital/qg',
                'nl': 'http://www.pearsonclinical.nl/over-pearson',
                'no': 'https://www.pearsonclinical.no/om-pearson',
                'sv': 'https://www.pearsonassessment.se/om-pearson'
            }
        },
        ui: {
            showFooter: true,
            showBrandBadge: true,
            showNavRegion: false,
            logoType: 'standard',
            logo: require('@/assets/images/QglobalLogo.svg'),
            logoId: 'QGlogoImg',
            logoContainerClass: 'Qi-Qg-image-align',
            logoAlt: 'QGlobal-logo',
            logoWidth: '210px',
            logoHeight: '230px'
        }
    },
    GED: {
        name: 'GED',
        links: {
            terms: { default: 'https://app.ged.com/cms?content=gedManagerTermsConditions' },
            privacy: { default: 'https://www.pearson.com/privacy-center/privacy-notices.html' }
        },
        ui: {
            showFooter: true,
            showBrandBadge: false,
            showNavRegion: false,
            showPearsonLink: false,
            logoType: 'gedImage',
            logo: require('@/assets/images/GED_LOGO.png'),
            logoId: 'GEDLogoImg',
            logoContainerClass: 'GED-image-align',
            logoAlt: 'GED-logo',
            logoWidth: '180px',
            logoHeight: '102px',
            copyrightText: {
                companyName: ' GED Testing Service LLC. ',
                allRightsReserved: 'All rights reserved.'
            }
        }
    },
    QI: {
        name: 'QI',
        links: {
            terms: {
                default: 'https://www.pearsonassessments.com/footer/terms-of-sale---use.html',
                'en-us': 'https://www.pearsonassessments.com/footer/terms-of-sale---use.html',
                'en-au': 'https://www.pearsonclinical.com.au/legal/terms-of-sale-use.html',
                'en-ca': 'https://www.pearsonclinical.ca/en/legal/terms-of-sale-use.html',
                'en-gb': 'https://www.pearsonclinical.co.uk/legal/terms-of-sale-use.html',
                'fr': 'https://admin.pearsonclinical.eu/media/wysiwyg/CGV_2023.pdf',
                'es': 'https://www.pearsonclinical.es/aviso-legal',
                'da': 'https://www.pearsonclinical.dk/bestillingsvilkar',
                'de': 'https://www.pearsonclinical.de/agb',
                'nl': 'https://www.pearsonclinical.nl/over-pearson/klantenservice/algemene-voorwaarden',
                'no': 'https://www.pearsonclinical.no/bestillingsvilkar-no',
                'sv': 'https://www.pearsonclinical.se/bestallningsvillkor'
            },
            privacy: {
                default: 'https://www.pearsonassessments.com/footer/pearson-clinical-privacy-policy.html',
                'en-us': 'https://www.pearsonassessments.com/footer/pearson-clinical-privacy-policy.html',
                'en-au': 'https://www.pearsonclinical.com.au/legal/pearson-clinical-privacy-policy.html',
                'en-ca': 'https://www.pearsonclinical.ca/en/legal/pearson-clinical-privacy-policy.html',
                'en-gb': 'https://www.pearsonclinical.co.uk/legal/pearson-clinical-privacy-policy.html',
                'fr': 'https://www.pearsonclinical.fr/avis_de_confidentialite',
                'es': 'https://www.pearsonclinical.es/politica-privacidad',
                'da': 'https://www.pearsonclinical.dk/dine-personlige-data',
                'de': 'https://www.pearsonclinical.de/datenschutz',
                'nl': 'https://www.pearsonclinical.nl/privacy-policy',
                'no': 'https://www.pearsonclinical.no/personvern',
                'sv': 'https://www.pearsonclinical.se/personuppgifter'
            },
            accessibility: {
                default: 'https://www.pearson.com/en-us/legal-information/accessibility',
                'en-us': 'https://www.pearson.com/en-us/legal-information/accessibility',
                'en-gb': 'https://www.pearson.com/uk/legal-information/accessibility.html',
                'en-ca': 'https://www.pearson.com/ca/legal-information/accessibility.html',
                'en-au': 'https://www.pearson.com/en-au/legal-information/accessibility.html'
            },
            modernSlavery: {
                default: '',
                'en-gb': 'https://www.pearson.com/uk/legal-information/modern-slavery-statement.html'
            },
            doNotSell: {
                default: 'https://www.pearson.com/privacy/california-consumer-privacy-act.html',
                'en-us': 'https://www.pearson.com/privacy/california-consumer-privacy-act.html'
            },
            businessAssociate: {
                default: 'https://qiactive.com/choose-share/pearsonPolicy/showLegalLinks?countryCode=US&policyDescription=Business+Associate+Addendum',
                'en-us': 'https://qiactive.com/choose-share/pearsonPolicy/showLegalLinks?countryCode=US&policyDescription=Business+Associate+Addendum'
            },
            contact: {
                default: 'https://support.pearson.com/usclinical/s/contactsupport',
                'en-us': 'https://support.pearson.com/usclinical/s/contactsupport',
                'en-au': 'https://support.pearson.com/usclinical/s/contactsupport',
                'en-ca': 'https://support.pearson.com/usclinical/s/contactsupport',
                'en-gb': 'https://support.pearson.com/usclinical/s/contactsupport',
                'fr': 'https://support.pearson.com/usclinical/s/contactsupport',
                'es': 'https://support.pearson.com/usclinical/s/contactsupport',
                'da': 'https://support.pearson.com/usclinical/s/contactsupport',
                'de': 'https://support.pearson.com/usclinical/s/contactsupport',
                'nl': 'https://support.pearson.com/usclinical/s/contactsupport',
                'no': 'https://support.pearson.com/usclinical/s/contactsupport',
                'sv': 'https://support.pearson.com/usclinical/s/contactsupport'
            },
            license: {
                default: 'https://qiactive.com/choose-share/pearsonPolicy/showLegalLinks?countryCode=US&policyDescription=Q-interactive+Licensing+Agreement',
                'en-us': 'https://qiactive.com/choose-share/pearsonPolicy/showLegalLinks?countryCode=US&policyDescription=Q-interactive+Licensing+Agreement',
                'en-au': 'https://qiactive.com/choose-share/pearsonPolicy/showLegalLinks?countryCode=AU&policyDescription=New+Psych+and+Speech+license+pricing+updates',
                'en-ca': 'https://qiactive.com/choose-share/pearsonPolicy/showLegalLinks?countryCode=CA&policyDescription=Terms+of+Use',
                'en-gb': 'https://qiactive.com/choose-share/pearsonPolicy/showLegalLinks?countryCode=GB&policyDescription=License+Terms+and+Conditions',
                'fr': 'https://qiactive.com/choose-share/pearsonPolicy/showLegalLinks?countryCode=FR&policyDescription=Terms+of+Use',
                'es': 'https://qiactive.com/choose-share/pearsonPolicy/showLegalLinks?countryCode=ES&policyDescription=Acuerdo+de+suscripci%C3%B3n+y+licencia+de+Q-interactive',
                'da': 'https://qiactive.com/choose-share/pearsonPolicy/showLegalLinks?countryCode=DK&policyDescription=Terms+of+Use',
                'de': 'https://qiactive.com/choose-share/pearsonPolicy/showLegalLinks?countryCode=DE&policyDescription=Terms+of+Use',
                'nl': 'https://qiactive.com/choose-share/pearsonPolicy/showLegalLinks?countryCode=DK&policyDescription=Terms+of+Use',
                'no': 'https://qiactive.com/choose-share/pearsonPolicy/showLegalLinks?countryCode=NO&policyDescription=Terms+of+Use',
                'sv': 'https://qiactive.com/choose-share/pearsonPolicy/showLegalLinks?countryCode=DK&policyDescription=Terms+of+Use'
            },
            about: {
                default: 'https://www.pearsonassessments.com/professional-assessments/digital-solutions.html',
                'en-us': 'https://www.pearsonassessments.com/professional-assessments/digital-solutions.html',
                'en-au': 'https://www.pearsonclinical.com.au/about',
                'en-ca': 'https://www.pearsonclinical.ca/about.html',
                'en-gb': 'https://www.pearsonclinical.co.uk/about.html',
                'fr': 'https://www.pearsonclinical.fr/qui-sommes-nous/ecpa-pearson',
                'es': 'https://www.pearsonclinical.es/sobre-pearson',
                'da': 'https://www.pearsonassessment.dk/om-pearson',
                'de': 'https://www.pearsonclinical.de/digital/qi',
                'nl': 'http://www.pearsonclinical.nl/over-pearson',
                'no': 'https://www.pearsonclinical.no/om-pearson',
                'sv': 'https://www.pearsonassessment.se/om-pearson'
            }
        },
        ui: {
            showFooter: true,
            showBrandBadge: true,
            showNavRegion: false,
            logoType: 'composite',
            logoId: 'QIlogoImg',
            logoContainerClass: 'Qi-Qg-image-align',
            logoImages: [
                {
                    src: require('@/assets/images/Qi_Logo1.svg'),
                    alt: 'QInteractive-logo',
                    width: '170px',
                    height: 'auto',
                    class: 'Qilogo-img'
                },
                {
                    src: require('@/assets/images/Qi_Text.svg'),
                    alt: 'QInteractive-Text',
                    width: '190px',
                    height: 'auto',
                    class: 'Qilogo-text'
                }
            ]
        }
    },
    PCAS: {
        name: 'PCAS',
        links: {},
        ui: {
            showFooter: true,
            showBrandBadge: true,
            showNavRegion: true,
            logoType: 'container', // Uses the default container with text
            logo: null // Will use pearsonLogoUrl() as fallback
        }
    },
    FAETHM: {
        name: 'FAETHM',
        links: {
            termsofuse: { default: 'https://www.pearson.com/en-us/legal-information/terms-of-use.html' },
            privacy: { default: 'https://www.faethm.ai/privacy' },
            accessibility: { default: 'https://www.pearson.com/en-us/legal-information/accessibility.html' },
            // contact: { default: 'https://www.faethm.ai/contact' },
            // license: { default: 'https://www.faethm.ai/license' },
            // about: { default: 'https://www.faethm.ai/' },
            cookieConsent: { default: 'https://www.pearson.com/en-us/legal-information/cookie-policy.html' }
        },
        ui: {
            showFooter: true,
            showBrandBadge: false,
            showPearsonLink: false,
            showNavRegion: false,
            logoType: 'none',
            logo: require('@/assets/images/PEARSON_LOGO_PURPLE_RGB.svg'),
            logoWidth: '119.46px',
            logoClass: 'main-logo side-logo faethm-pearson-logo',
            copyrightText: {
                companyName: ' Pearson.',
                allRightsReserved: 'All Rights Reserved.'
            }
        }
    },
    REVIBE: {
        links: {
        },
        ui: {
            logo: require('@/assets/images/Revibe-logo.png')
        }
    },
    BASE: {
        name: 'BASE',
        links: {
            terms: { default: 'https://www.pearson.com/en-us/legal-information/terms-of-use.html' },
            privacy: { default: 'https://www.pearson.com/en-us/about/legal-notice/privacy-notice.html' },
            accessibility: { default: 'https://www.pearson.com/en-us/legal-information/accessibility' },
            contact: { default: 'https://www.pearson.com/en-us/contact-us.html' },
            license: { default: '' }, // optional
            about: { default: 'https://www.pearson.com' }
        },
        ui: {
            showFooter: false,
            showBrandBadge: false,
            showNavRegion: false,
            logoType: 'container', // Uses the default container with text
            logo: null, // Will use pearsonLogoUrl() as fallback
            copyrightYearInRange: false
        }
    }
};

// 2) List clients by theme (add your QG clients here)
export const QG_CLIENTS = [
    'QGlobal-Client',
    'QGlobalCA-Client'
];
export const GED_CLIENTS = [
    'ged-client',
    'ged-student-client'
];
export const QI_CLIENTS = [
    'QInteractive-Client',
    'https://dev.qiactive.com/choose-share/saml2/service-provider-metadata/ies',
    'https://qa.qiactive.com/choose-share/saml2/service-provider-metadata/ies',
    'https://staging.qiactive.com/choose-share/saml2/service-provider-metadata/ies',
    'https://qiactive.com/choose-share/saml2/service-provider-metadata/ies',
    'https://us.qa.qiactive.com/choose-share/saml2/service-provider-metadata/ies',
    'https://us.qiactive.com/choose-share/saml2/service-provider-metadata/ies'
];

export const PCAS_CLIENTS = [
    'PCASUS-Client',
    'PCASCA-Client',
    'PCASUK-Client',
    'PCASAN-Client',
    'PCASAP-Client',
    'PCASNL-Client',
    'PCASES-Client'
];

export const FAETHM_CLIENTS = [
    'faethm',
    'FAETHM-Client',
    'urn:auth0:faethm-stage:sso-ies-saml',
    'urn:auth0:faethm-production:sso-ies-saml'
];

export const BOB_CLIENTS = [
    'BOB_Client',
    'BOB_CLIENT',
    'urn:amazon:cognito:sp:eu-west-2_XZu0X6Su0',
    'urn:amazon:cognito:sp:eu-west-2_ueF9h61zD'
];
// 3) Optional per-client overrides on top of theme defaults (e.g., locales or different links)
export const CLIENT_OVERRIDES = {
    'PCASUS-Client': {
        links: {
            termsofuse: { default: 'https://www.pearson.com/en-us/legal-information/terms-of-use.html' },
            privacy: { default: 'https://www.pearson.com/en-us/privacy-center/privacy-notices.html' },
            contact: { default: 'https://support.pearson.com/usclinical/s/contactsupport' },
            doNotSell: { default: 'https://www.pearson.com/en-us/legal-information/cookie-policy.html#do-not-sell-or-share-my-data' },
            patentNotice: { default: 'https://www.pearson.com/en-us/legal-information/patent-notice.html' },
            accessibility: { default: 'https://www.pearson.com/en-us/legal-information/accessibility.html' },
            cookies: { default: 'https://www.pearson.com/en-us/legal-information/cookie-policy.html' }
        },
        ui: {
            pearsonLinkHref: 'https://www.pearson.com/en-us.html',
            showNavRegion: true,
            copyrightYearInRange: true,
            showCookies: true
        }
    },
    'QGlobal-Client': {
        ui: {
            showNavRegion: true
        }
    },
    'PCASCA-Client': {
        links: {
            termsofuse: { default: 'https://www.pearson.com/en-ca/legal-information/terms-of-use.html' },
            privacy: { default: 'https://www.pearson.com/en-ca/privacy-center/privacy-notices.html' },
            contact: {
                default: 'https://www.pearsonclinical.ca/en/contact-us.html',
                en: 'https://www.pearsonclinical.ca/en/contact-us.html',
                fr: 'https://www.pearsonclinical.ca/fr/nous-contacter.html'
            },
            patentNotice: { default: 'https://www.pearson.com/en-ca/legal-information/patent-notice.html' },
            accessibility: { default: 'https://www.pearson.com/en-ca/legal-information/accessibility.html' },
            cookies: { default: 'https://www.pearson.com/en-us/legal-information/cookie-policy.html' }
        },
        ui: {
            showPearsonLink: true,
            copyrightYearInRange: true,
            pearsonLinkHref: 'https://www.pearson.com/en-us.html',
            showNavRegion: true,
            showCookies: true
        }
    },
    'PCASUK-Client': {
        links: {
            termsofuse: { default: 'https://www.pearson.com/en-gb/legal-information/terms-of-use.html' },
            privacy: { default: 'https://www.pearson.com/en-gb/legal-information/privacy-notice.html' },
            contact: { default: 'https://www.pearsonclinical.co.uk/contact-us.html' },
            accessibility: { default: 'https://www.pearson.com/en-gb/legal-information/accessibility.html' },
            modernSlavery: { default: 'https://www.pearson.com/en-gb/legal-information/our-policies/modern-day-slavery.html' },
            patentNotice: { default: 'https://www.pearson.com/en-gb/legal-information/patent-notice.html' },
            cookies: { default: 'https://www.pearson.com/en-us/legal-information/cookie-policy.html' }
        },
        ui: {
            pearsonLinkHref: 'https://www.pearson.com/en-us.html',
            copyrightYearInRange: true,
            showNavRegion: true,
            showCookies: true
        }
    },
    'PCASAN-Client': {
        links: {
            termsofuse: { default: 'https://www.pearsonclinical.com.au/legal/terms-of-sale-use.html' },
            privacy: { default: 'https://www.pearsonclinical.com.au/legal/pearson-clinical-privacy-policy.html' },
            contact: { default: 'https://www.pearsonclinical.com.au' },
            doNotSell: { default: 'https://www.pearson.com/en-us/legal-information/cookie-policy.html#donot' },
            patentNotice: { default: 'https://www.pearson.com/en-us/legal-information/patent-notice.html' },
            accessibility: { default: 'https://www.pearson.com/en-us/legal-information/accessibility.html' },
            cookies: { default: 'https://www.pearson.com/en-us/legal-information/cookie-policy.html' }
        },
        ui: {
            pearsonLinkHref: 'https://www.pearson.com/en-us.html',
            copyrightYearInRange: true,
            showNavRegion: true,
            showCookies: true
        }
    },
    'PCASAP-Client': {
        links: {
            termsofuse: { default: 'https://www.pearsonclinical.asia/legal/terms-of-sale-use.html' },
            privacy: { default: 'https://www.pearsonclinical.asia/legal/pearson-clinical-privacy-policy.html' },
            contact: { default: 'https://www.pearsonclinical.asia/contact-us.html' },
            accessibility: { default: 'https://www.pearson.com/en-us/legal-information/accessibility.html' },
            patentNotice: { default: 'https://www.pearson.com/en-us/legal-information/patent-notice.html' },
            cookies: { default: 'https://www.pearson.com/en-us/legal-information/cookie-policy.html' }
        },
        ui: {
            pearsonLinkHref: 'https://www.pearson.com/en-us.html',
            showNavRegion: true,
            copyrightYearInRange: true,
            showCookies: true
        }
    },
    'PCASNL-Client': {
        links: {
            termsofuse: { default: 'https://www.pearsonclinical.nl/wetgeving/algemene-voorwaarden.html' },
            privacy: { default: 'https://www.pearsonclinical.nl/wetgeving/privacyverklaring.html' },
            contact: { default: 'https://www.pearsonclinical.nl/forms/contact-us-form.html' },
            accessibility: { default: 'https://www.pearson.com/nl/nl_NL/accessibility.html' },
            patentNotice: { default: 'https://www.pearson.com/en-us/legal-information/patent-notice.html' },
            cookies: { default: 'https://www.pearson.com/en-us/legal-information/cookie-policy.html' }
        },
        ui: {
            showPearsonLink: true,
            copyrightYearInRange: true,
            pearsonLinkHref: 'https://www.pearson.com/en-us.html',
            showNavRegion: true,
            showCookies: true
        }
    },
    'PCASES-Client': {
        links: {
            termsofuse: { default: 'https://www.pearsonclinical.es/aviso-legal' },
            privacy: { default: 'https://www.pearsonclinical.es/politica-privacidad' },
            contact: { default: 'https://www.pearsonclinical.es/contactenos/formulario-de-contacto.html' },
            accessibility: { default: 'https://www.pearson.com/us/accessibility.html?locale=es' },
            patentNotice: { default: 'https://www.pearson.com/en-us/legal-information/patent-notice.html' },
            cookies: { default: 'https://www.pearson.com/en-us/legal-information/cookie-policy.html' }
        },
        ui: {
            pearsonLinkHref: 'https://www.pearson.com?locale=es',
            copyrightYearInRange: true,
            showNavRegion: true,
            showCookies: true
        }
    },
    'https://us.qa.qiactive.com/choose-share/saml2/service-provider-metadata/ies': {
        ui: {
            showNavRegion: true
        }
    },
    'https://us.qiactive.com/choose-share/saml2/service-provider-metadata/ies': {
        ui: {
            showNavRegion: true
        }
    }
};

// Utility to pick a link by locale with fallback to default
export function pickLink (linksObj, locale) {
    if (!linksObj) return '';
    console.log('LinksObj:', linksObj, 'Locale:', locale);
    // If we have a specific locale match, use it
    if (locale && linksObj[locale.toLowerCase()]) {
        return linksObj[locale.toLowerCase()];
    }

    // Try matching just the language part if region-specific link isn't found
    if (locale && locale.indexOf('-') > 0) {
        const langOnly = locale.split('-')[0];
        const matchingKeys = Object.keys(linksObj).filter(key =>
            key.startsWith(langOnly + '-') || key === langOnly
        );

        if (matchingKeys.length > 0) {
            return linksObj[matchingKeys[0]];
        }
    }
    // Fallback to default
    return linksObj.default || '';
}
